import type { EnumUnion } from '@dresscode-frontend/utility-types';

import type { GetProxyUserListItem } from '../../../-types';

export const ProxyUserTableColumns = {
  LOGIN_ID: 'LOGIN_ID',
  PERSON: 'PERSON',
  IT_SERVICES: 'IT_SERVICES',
} as const;
export type ProxyUserTableColumns = EnumUnion<typeof ProxyUserTableColumns>;

type IdManagementTablePersonColumn = GetProxyUserListItem['person'];
type IdManagementTableItServiceColumn = GetProxyUserListItem['apps'][number];

export type ProxyUserTableRow = {
  [ProxyUserTableColumns.LOGIN_ID]: {
    loginId: string;
    matchType?: NonNullable<GetProxyUserListItem['person']>['matchType'];
    matchTypeLabel?: string;
  };
  [ProxyUserTableColumns.PERSON]: IdManagementTablePersonColumn;
  [ProxyUserTableColumns.IT_SERVICES]: IdManagementTableItServiceColumn[];
};

export type MatchType = NonNullable<
  GetProxyUserListItem['person']
>['matchType'];

export const convertProxyUserItemToTableRow = (
  item: GetProxyUserListItem,
): ProxyUserTableRow => {
  return {
    [ProxyUserTableColumns.LOGIN_ID]: {
      loginId: item.loginId,
      matchType: item.person?.matchType,
      matchTypeLabel: item.person?.matchTypeLabel,
    },
    [ProxyUserTableColumns.PERSON]: item.person,
    [ProxyUserTableColumns.IT_SERVICES]: item.apps,
  };
};
